import { ModalAPI } from '@philips-internal/oswald-ui-components';
import { ModalType } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isMobile } from '@philips-internal/oswald-ui-utils';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import BaseController from '../BaseController';

import './privacy-modal.css';
@Controller({ component: 'modal-privacy', fragment: 'privacy-modal' })
class PrivacyModalController extends BaseController {

  @OnMount({ target: 'modal-privacy' })
  onMountModalTermsUseDetail(event: MountEvent): void {
    const nrSeqAviso = this.getHistoryRouteParam<Value>('nrSeqAviso');
    this.context.set({ nrSeqAviso });

    const modal = event.target as ModalAPI;
    if(isMobile()) {
      modal.setType(ModalType.FULLSCREEN);
    }
  }

  @OnClose({ target: 'modal-privacy' })
  onClose(): void {
    this.historyService.push(APPLICATION_ROUTES.PROFILE_PRIVACY);
  }

}

export default PrivacyModalController;